import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class CoverholderProducts extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderProducts';
  }

  static getOfflineRaters() {
    return api.get('/GetOfflineRaters');
  }
}

export default CoverholderProducts;
